import { render, staticRenderFns } from "./UserTenantFormModal.vue?vue&type=template&id=a966f4da"
import script from "./UserTenantFormModal.vue?vue&type=script&lang=js"
export * from "./UserTenantFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports